import PropTypes from 'prop-types';

// material-ui
import { Box, Card, Grid, useMediaQuery } from '@mui/material';

// project import
import AuthFooter from 'components/cards/AuthFooter';
import Logo from 'components/logo';
import AuthCard from './AuthCard';

// assets
import companyPng from 'assets/images/logo/company.png';
import AuthBackground from 'assets/images/auth/AuthBackground';
import PicLogin from 'assets/images/layer-enhancement/pic_login.png';

import { useTheme } from '@mui/material/styles';
import { display } from '@mui/system';

// ==============================|| AUTHENTICATION - WRAPPER ||============================== //

const AuthWrapper = ({ children }) => {
  const theme = useTheme();
  const matchesxs = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#ffffff' }}>
      {/* <AuthBackground /> */}
      {/* <Grid item xs={12} sx={{ ml: 3, mt: 3 }}>
        <Logo sx={{display: 'inline'}}/>
      </Grid> */}
      <Grid
        container
        direction={matchesxs ? 'column' : 'row'}
        // justifyContent="flex-end"
        sx={{
          minHeight: '100vh'
        }}
      >
        <Grid
          item
          xs={6}
          sx={{
            position: 'relative',
            '&:after': {
              content: "''",
              height: '100%',
              width: '2vw',
              bgcolor: '#ffffff',
              position: 'absolute',
              right: '-2vw',
              top: 0,
              borderTopRightRadius: '60px',
              borderBottomRightRadius: '60px',
              display: matchesxs && 'none'
            }
          }}
        >
          <Grid
            container
            direction="column"
            sx={{
              minHeight: '100vh',
              borderTopRightRadius: '60px',
              borderBottomRightRadius: '60px'
              // background: '#242424'
            }}
          >
            <Grid item xs={12} sx={{ ml: 3, mt: 3 }}>
              <Logo sx={{ justifyContent: 'flex-start' }} />
            </Grid>
            <Grid item xs={12}>
              <Grid
                item
                xs={12}
                container
                justifyContent="center"
                alignItems="center"
                sx={{ minHeight: { xs: 'calc(100vh - 210px)', sm: 'calc(100vh - 134px)', md: 'calc(100vh - 112px)' } }}
              >
                <Grid item>
                  <AuthCard boxShadow={false}>{children}</AuthCard>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* <Grid item xs={12} sx={{ m: 3, mt: 1 }}>
        <AuthFooter />
      </Grid> */}
        </Grid>
        <Grid item xs={6} sx={{ display: matchesxs && 'none' }}>
          <Box
            sx={{
              backgroundImage: `url(${PicLogin})`,
              backgroundSize: '100% 100%',
              height: '100%',
              backgroundRepeat: 'no-repeat'
            }}
          />
          {/* <AuthBackground /> */}
        </Grid>
      </Grid>
    </Box>
  );
};

AuthWrapper.propTypes = {
  children: PropTypes.node
};

export default AuthWrapper;
